import { render, staticRenderFns } from "./BaseItemCompetitionPromoted.vue?vue&type=template&id=7bc1a1df&"
import script from "./BaseItemCompetitionPromoted.vue?vue&type=script&lang=js&"
export * from "./BaseItemCompetitionPromoted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bc1a1df')) {
      api.createRecord('7bc1a1df', component.options)
    } else {
      api.reload('7bc1a1df', component.options)
    }
    module.hot.accept("./BaseItemCompetitionPromoted.vue?vue&type=template&id=7bc1a1df&", function () {
      api.rerender('7bc1a1df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseItemCompetitionPromoted.vue"
export default component.exports